export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  PANIC = 'PANIC',
}

export const logLevelOptions = Object.values(LogLevel);
